export default {
  'verificationcheck.verifycode': 'VERIFY CODE',
  'verificationcheck.gotoprofile': 'Go To Profile',
  'verificationcheck.entercode': 'Enter verification code',
  'verificationcheck.maintext':
    'To continue please enter verification code here , the code has been sent to ',
  'verificationcheck.continuetext': '.',
  'verificationcheck.evaluate': 'EVALUATE',
  'verificationcheck.resendcode': 'Click To Resend Code',
};
